<template>
<div class="PC_start_page">
   <HeaderC></HeaderC>
   <router-view />
</div>
</template>

<script>
import HeaderC from "./components/HeaderC"
export default {
   components: {
      HeaderC
   }
};
</script>

<style lang="scss" scoped>
.PC_start_page {
   width: 100%;
   height: 100%;
   font-size: 16Px;
}
</style>
